import { PageHeader } from "@/components/PageHeader";
import { InventoryUpload } from "@/components/admin/InventoryUpload";
import { UsersPanel } from "@/components/admin/UsersPanel";
import { CompanySettings } from "@/components/admin/CompanySettings";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Admin() {
  return (
    <div>
      <PageHeader title="Admin" subtitle="Inventory uploads, users and company details" />
      <Tabs defaultValue="inventory">
        <TabsList className="mb-6 h-auto max-w-full flex-wrap justify-start">
          <TabsTrigger value="inventory" data-testid="admin-tab-inventory">Inventory upload</TabsTrigger>
          <TabsTrigger value="users" data-testid="admin-tab-users">Users</TabsTrigger>
          <TabsTrigger value="company" data-testid="admin-tab-company">Company & PDF</TabsTrigger>
        </TabsList>
        <TabsContent value="inventory"><InventoryUpload /></TabsContent>
        <TabsContent value="users"><UsersPanel /></TabsContent>
        <TabsContent value="company"><CompanySettings /></TabsContent>
      </Tabs>
    </div>
  );
}
